const getStoreFromLocalizer = () => {
  let localStore;

  if (typeof window !== 'undefined') {
    localStore = window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getLocalizedStore();
  }

  if (localStore === null || localStore === undefined) {
    return '';
  }
  return localStore;
};

const getThdStore = () => {
  const store = getStoreFromLocalizer();
  if (store) {
    return {
      ...store,
      storeNumber: store.storeId,
      storeName: store.name,
      zipcode: store.zipcode,
    };
  }
  return {
    storeNumber: 121,
    storeFullName: 'Cumberland - Atlanta, GA',
    storeName: 'Cumberland',
    zipcode: '30339',
  };
};

export default getThdStore;
